import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { WidgetContent } from '../Widget'
import { Widget, Box, Tooltip, Icon } from '@maui/elements'
import Scrollbars from '../Scrollbars'
import ArticlesWidgetItem from './ArticlesWidgetItem'

const ArticlesWidget = (props) => {
  const {
    autoHeight = true,
    children,
    className,
    scrollable = true,
    info = 'Relevant Reporting',
    header,
    height = 330,
    ...widgetProps
  } = props

  const content = useMemo(() => {
    if (!scrollable) {
      return children
    }

    return (
      <Scrollbars autoHeight={autoHeight}>
        <div style={{ paddingRight: 12 }}>
          {children}
        </div>
      </Scrollbars>
    )
  }, [autoHeight, scrollable, children])

  return (
    <Widget
      className={className}
      info={info}
      title={
        <Box display="flex" alignItems="center" justifyContent="center" gap="spaceGapMedium">
          {header}
          <Tooltip placement="bottom" tooltip={info} >
            <Icon name="info" verticalAlign="top" />
          </Tooltip>
        </Box>}
      {...widgetProps}
    >
      <Box overflow="auto" height={height}>
        {content}
      </Box>
    </Widget>
  )
}

ArticlesWidget.Item = ArticlesWidgetItem

ArticlesWidget.propTypes = {
  autoHeight: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
  scrollable: PropTypes.bool,
  info: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
}

export default styled(ArticlesWidget)`
  ${WidgetContent} {
    padding-right: 4px;
  }
`
